import React from 'react';
import Rodal from 'rodal';
import 'rodal/lib/rodal.css';
import LocaleSelection from '../utils/locale/setLocale';
import styled from 'styled-components';

function Modal({
  children,
  closeMaskOnClick = true,
  handleModalClose = () => {},
  showCloseButton = true,
  visible = false,
  displayLocaleSelection = false,
}) {
  const modalStyles = {
    height: 'fit-content',
    width: '100%',
    maxWidth: 'fit-content',
    overflow: 'auto',
  };

  return (
    <>
      {displayLocaleSelection ? (
        <LocaleSelectionContainer>
          <LocaleSelection />
        </LocaleSelectionContainer>
      ) : null}
      <Rodal
        closeMaskOnClick={closeMaskOnClick}
        customStyles={modalStyles}
        onClose={handleModalClose}
        showCloseButton={showCloseButton}
        visible={visible}
      >
        {children}
      </Rodal>
    </>
  );
}

export default Modal;

const LocaleSelectionContainer = styled.div`
  z-index: 101;
  width: 100vw;
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: 0.5em;
`;
